module.exports = __webpack_public_path__ + "static/media/close-icon.84eeb58b.svg";